template = require('./confetti.html.slim')

angular.module('wbComponents').directive 'wbConfetti',
['$rootScope', ($rootScope) ->
  restrict: 'E'
  templateUrl: template

  link: ($scope, $el, $attrs) ->
    NUM_CONFETTI = 120
    COLORS = [[20, 205, 168], [105, 195, 13], [40, 145, 1], [13, 86, 75], [31, 128, 115], [255, 255, 255]]
    PI_2 = 2*Math.PI

    canvas = document.getElementById "confetti"
    context = canvas.getContext "2d"
    w = 0
    h = 0

    step = ->
      context.clearRect(0,0,w,h)
      c.draw() for c in confetti
      window.requestAnimationFrame(step)

    resizeWindow = ->
      w = canvas.width = window.innerWidth
      canvas.width = window.innerWidth
      h = canvas.height = $('.page-cover-home').height()
      canvas.height = $('.page-cover-home').height()

    window.addEventListener 'resize', resizeWindow, false

    window.onload = -> setTimeout resizeWindow, 0

    range = (a,b) -> (b-a)*Math.random() + a

    drawCircle = (x,y,r,style) ->
      context.beginPath()
      context.arc(x,y,r,0,PI_2,false)
      context.fillStyle = style
      context.fill()

    xpos = 0.5

    class Confetti
      constructor: ->
        @style = COLORS[~~range(0,5)]
        @r = ~~range(2,5)
        @r2 = 2*@r
        @replace()
        @speed = 0.75

      replace: ->
        @opacity = 0
        @dop = 0.03*range(1,4)
        @x = range(-@r2,w-@r2)
        @y = range(-20,h-@r2)
        @xmax = w-@r
        @ymax = h-@r
        @vx = range(0,2)+8*xpos-5
        @vy = 0.7*@r+range(-1,1)

      color: ->
        "rgba(#{@style[0]},#{@style[1]},#{@style[2]}, #{@opacity})"

      draw: ->
        @x += @vx*@speed
        @y += @vy*@speed
        @opacity += @dop*@speed
        if @opacity > 1
          @opacity = 1
          @dop *= -1
        @replace() if @opacity < 0 or @y > @ymax
        if !(0 < @x < @xmax)
          @x = (@x + @xmax) % @xmax
        drawCircle(~~@x,~~@y,@r, @color())
    confetti = (new Confetti for i in [1..NUM_CONFETTI])

    $rootScope.$on 'startConfetti', =>
      window.requestAnimationFrame(step)

]
